import { useQuery } from '@tanstack/react-query';
import { notificationService } from '../services/notificationService';

/**
 * Hook to fetch unread notification count
 * Refetches frequently to keep badge updated
 */
export const useUnreadCount = () => {
  return useQuery({
    queryKey: ['notifications', 'unread-count'],
    queryFn: () => notificationService.getUnreadCount(),
    staleTime: 30 * 1000, // 30 seconds
    refetchInterval: 30 * 1000, // Auto-refresh every 30 seconds
    refetchOnWindowFocus: true, // Refresh when user returns to tab
  });
};
